import { useCallback, useState } from 'react';

export const useFocusAnchor = <T extends HTMLElement>() => {
	const [isFocused, setIsFocused] = useState(false);
	const [anchorEl, setAnchorEl] = useState<T | null>(null);

	const onFocus = useCallback(() => setIsFocused(true), []);
	const onBlur = useCallback(() => setIsFocused(false), []);

	return { isFocused, anchorEl, onFocus, onBlur, setAnchorEl };
};
